import ListRetailCashSales from "../../../../components/@documents/retail_cash_sales/ListRetailCashSales";

import { routeTypes } from "../../../../hooks/useSystemRoutes";

export default function RetailCashSalesPage() {

    return (
        <ListRetailCashSales 
            routeType={routeTypes.admin}
        />
    )
}